import { render } from "./Button.vue?vue&type=template&id=63b118a8&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=63b118a8&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/solution/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63b118a8"]])

export default __exports__